module.exports = __webpack_public_path__ + "img/A-274826-1293673804.jpeg.39c572e7.jpg";